import {
  Alert,
  Button,
  Card,
  Checkbox,
  Form,
  Input,
  message,
  Typography,
} from "antd";
import qs from "qs";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import LogoBackground from "assets/images/diary-bg-img.jpg";
import Logo from "assets/images/logo.svg";
import UserVerificationModal from "features/register/userVerificationModal";
import User from "models/user/user";
import {
  deleteQueryParam,
  downloadEvent,
  redirectToUrl,
} from "utilities/generalUtility";
import GoogleLogin from "utilities/googleLogin";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { saveGlobalLoader } from "redux/diaries/diariesSlice";

export default function Login() {
  const dispatch = useDispatch();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const [form] = Form.useForm();
  const inputRef = useRef(null);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const email = useRef();
  const [isError, setIsError] = useState({ status: false, message: "" });

  const paramJson = qs.parse(location.search, { ignoreQueryPrefix: true });

  const showModal = () => {
    setIsModalOpen(true);
  };
  useEffect(() => {
    inputRef?.current && inputRef?.current?.focus();

    if (paramJson.err) {
      message.error(paramJson.err);
      deleteQueryParam("err");
    }
    queryParams.get("Email") &&
      form.setFieldsValue({
        email: queryParams.get("Email").replace(/ /g, "+"),
      });
  }, []);

  const onFinish = async (values) => {
    email.current = values.email;
    values.roleType = 2;
    try {
      const user = await dispatch(
        User.loginCall(
          values.roleType,
          values.email,
          values.password,
          values.remember
        )
      );
      user &&
        redirectToUrl(
          `${
            user?.data?.isSubscriptionConfirmed !== "false"
              ? "/journal-request"
              : "/sub-info"
          }`,
          queryParams.get("diaryId"),
          queryParams.get("diaryTopicId")
        );
    } catch (error) {
      dispatch(saveGlobalLoader(false));

      setIsError((prev) => {
        return {
          ...prev,
          status: true,
          message:
            error?.statusCode === 500
              ? "Someting went wrong!!!"
              : error.message,
        };
      });
      // message.error(error.message);
      error?.statusCode === 403 &&
        error.error.data.data.isEmailConfirmed === "False" &&
        showModal();
      // setFieldErrorsFromServer(error, form, values);
    }
  };

  const { Title } = Typography;

  return (
    <React.Fragment>
      <div className="login-container d-flex">
        <div className="login-bg w-100">
          <img className="login-img w-100 h-100" src={LogoBackground} alt="" />
        </div>
        <Card bordered={false} className="login-card">
          <div className="authentication-logo text-center">
            <img className="logo" src={Logo} alt="" />
          </div>
          <Title level={4}>Login</Title>
          {isError.status && (
            <Alert
              className="custom-alert"
              description={isError.message}
              showIcon
              icon={<ExclamationCircleFilled />}
            />
          )}
          <Form
            form={form}
            name="basic"
            initialValues={{
              remember: true,
            }}
            onFinish={onFinish}
            layout="vertical"
          >
            <Form.Item
              name="email"
              hasFeedback
              rules={[
                {
                  type: "email",
                  message: "The Input is not valid Email",
                },
                {
                  required: true,
                  message: "Please input your Email!",
                },
              ]}
            >
              <Input
                ref={inputRef}
                type="email"
                suffix={<i className="icon-email site-form-item-icon"></i>}
                placeholder="email"
                size="large"
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: "Please input your password!",
                },
              ]}
              className="mb-0"
            >
              <Input.Password
                placeholder="password"
                size="large"
                autoComplete="false"
              />
            </Form.Item>
            <Form.Item className="remember-checkbox">
              <Form.Item name="remember" valuePropName="checked" noStyle>
                {/* <Checkbox>Remember me</Checkbox> */}
                <p></p>
              </Form.Item>

              <Link to="/forgot-password" href="">
                Forgot your password?
              </Link>
            </Form.Item>
            <Form.Item className="mb-4">
              <Button
                block
                size="large"
                type="primary"
                htmlType="submit"
                onClick={() => {
                  downloadEvent("Login");
                }}
              >
                Login
              </Button>
            </Form.Item>
            <GoogleLogin form={form} />

            <Title level={5} className="text-center">
              Don’t have an Account?
              <Link to="/register">Sign Up</Link>
            </Title>
          </Form>
        </Card>
      </div>
      <UserVerificationModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        email={email?.current}
      />
    </React.Fragment>
  );
}
